// custom styles for buttons and icons
export const buttonsStyle = { width: "36px", height: "36px" }
export const iconsStyle = { fontSize: "18px" }
export const resetButtonsStyle = { border: 'none', background: 'unset', margin: '0 auto' }